export default (pid, cacheBust) => {
  const cb = cacheBust ? `?cb=${cacheBust}` : '';
  return `https://kodmunki-gifthorse-profile-images.s3.us-west-2.amazonaws.com/${pid}${cb}`
}
